module.exports = __webpack_public_path__ + "img/hsf.bcd6f74d.jpg";